module.exports = __webpack_public_path__ + "img/20191111165342049.1504f8dd.jpg";